import { NavLink } from "react-router-dom";

const NavLinks = () => {
    return (
        <ul>
            <li>
                <NavLink
                    to="/"
                    activeclassname="active"
                >
                    <span>Home</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="/about"
                    activeclassname="active"
                >
                    <span>About</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="/events"
                    activeclassname="active"
                >
                    <span>Events</span>
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="/contact"
                    activeclassname="active"
                >
                    <span>Contact</span>
                </NavLink>
            </li>
        </ul>
    )
}

export default NavLinks